module.exports = __webpack_public_path__ + "static/media/topVedio.86319b3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/topVedio.mp4
// module id = Jf+u
// module chunks = 1